import {
  Target,
  Rocket,
  TrendingUp,
  LineChart,
  GraduationCap,
  ClipboardList,
  ShieldCheck,
  Users,
  Search,
  Handshake,
  Factory,
  Pickaxe,
  Landmark,
  Cpu,
  HardHat,
  ShoppingCart,
  HeartPulse,
  Sprout,
  Truck,
  Plane,
  Building2,
  Building,
  Zap,
  Briefcase,
  Megaphone,
} from "lucide-react";

export const iconMap = {
  Target,
  Rocket,
  TrendingUp,
  LineChart,
  GraduationCap,
  ClipboardList,
  ShieldCheck,
  Users,
  Search,
  Handshake,
  Factory,
  Pickaxe,
  Landmark,
  Cpu,
  HardHat,
  ShoppingCart,
  HeartPulse,
  Sprout,
  Truck,
  Plane,
  Building2,
  Building,
  Zap,
  Briefcase,
  Megaphone,
};
